export enum BusinessRegistrationTypeApi {
  BUSINESS_REGISTRATION,
  RSA_ID,
}
